// extracted by mini-css-extract-plugin
export default {"root":"TooltipInfo_root__WTMr1","tooltip":"TooltipInfo_tooltip__GxEO7"};